import { Button, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import ModalV2 from '/@/components/bayer/modal-v2';
import settings from '/@/core/settings';
import { useDeleteUserNode, useGetUserNode, useOwnUserNode } from '/@/hooks/nodes';
import { _ } from '/@/locale';

const DeleteGrowerModal = ({
    growerNodeId,
    onSuccess,
    open,
    setOpen,
}: {
    growerNodeId: number;
    onSuccess: (growerName: string) => void;
    open: boolean;
    setOpen: (open: boolean) => void;
}) => {
    const deleteFieldMutation = useDeleteUserNode();
    const growerQuery = useGetUserNode(growerNodeId);

    const handleDeleteGrower = async () => {
        try {
            const growerName = growerQuery.data?.name || '';
            await deleteFieldMutation.trigger(growerNodeId);
            onSuccess(growerName);
            setOpen(false);
        } catch {
            enqueueSnackbar(_('Error al eliminar el productor'), {
                variant: 'error',
            });
        }
    };

    const ownNodeQuery = useOwnUserNode();
    const otherParentId = growerQuery.data?.parents?.find((parent) => parent !== ownNodeQuery.data?.id);
    const otherParentQuery = useGetUserNode(otherParentId ?? 0);

    return (
        <ModalV2
            open={open}
            onClose={() => setOpen(false)}
            title={_('Eliminar productor')}
            actions={
                <>
                    <Button
                        variant='text'
                        color='secondary'
                        onClick={() => setOpen(false)}
                        disabled={deleteFieldMutation.isMutating}
                    >
                        {_('Cancelar')}
                    </Button>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={() => handleDeleteGrower()}
                        disabled={deleteFieldMutation.isMutating}
                    >
                        {_('Eliminar productor')}
                    </Button>
                </>
            }
            actionsProps={{
                justifyContent: 'end',
            }}
        >
            <Typography variant='body1' color='primary' fontWeight='bold'>
                {_('¿Estás seguro que querés eliminar a este productor?')}
            </Typography>
            <Typography variant='body1' color='primary'>
                {otherParentQuery.data
                    ? _('Si eliminas este Productor, la información va a quedar disponible para {{rvOrAdvisorName}}.', {
                          rvOrAdvisorName: otherParentQuery.data?.name,
                      })
                    : _(
                          'Vas a eliminar a {{growerName}} de tu lista de productores en {{appName}}. Esta acción no se puede deshacer.',
                          { growerName: growerQuery.data?.name, appName: settings.app.name }
                      )}
            </Typography>
        </ModalV2>
    );
};

export default DeleteGrowerModal;
